<div class="row" style="max-width: 80%; margin: 0 auto; text-align: center;">
    <div class="col-sm-12">
        <div >
            <h1 class="page-label">Portal Validation - Dashboard</h1>
            <h4 class="page-label" style="color: white;">Selected Portal: {{ portal?.name }}</h4>
        </div>
        <div style="padding-top:20px;">
                    <h3 class="page-label" style="padding-bottom: 10px;">Status: {{ getDisplayState(validationInfo.state) }}</h3>
                    <h4 *ngIf="displayTableAndFunctions()" class="page-label" style="text-align: start;">Order Id: {{ validationInfo?.attempt?.order_id }}</h4>
                    <button class="submit btn btn-primary" *ngIf="!displayTableAndFunctions()" (click)="onBackButtonClicked()">Go back</button>
        </div>
    </div>
</div>


<ng-container *ngIf="displayTableAndFunctions()">
<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">SKU #</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Quantity Required #</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Quantity Read</div>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr role="row" *ngFor="let lineItem of validationInfo.attempt?.line_items; index as i;" [class.green-highlight]="isSuccessRow(lineItem)" [class.red-highlight]="isErrorRow(lineItem)" [class.yellow-highlight]="isPartialRow(lineItem)" [class.gray-highlight]="isUnknownRow(lineItem)">
            <td>
                {{ lineItem?.sku }}
            </td>
            <td>
                {{ lineItem?.quantity_required }}
            </td>
            <td>
                {{ lineItem?.quantity_read }}
            </td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onStartReaderClicked()" [disabled]="isReaderStarted() || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Start Reader</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onStopReaderClicked()" [disabled]="!isReaderStarted() || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Stop Reader</button>
    </div>
    <div class="col-sm-6">

    </div>
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onProcessClicked()" [disabled]="isReaderStarted() || isClearOrderBeingProcessed || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Process Order</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onBackButtonClicked()"  [disabled]="isReaderStarted() || isClearOrderBeingProcessed || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Go back</button>
    </div>
</div>

<!-- Spacer for the footer -->
<div class="row">
    <div style="height: 100px;"></div>
</div>
</ng-container>



<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog>
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>